<template>
  <div class="water-container" @dragover="handleDragOver" ref="container" @dragleave="isDragging=false">
    <grid-layout
      v-if="layout"
      :keep-item-size="true"
      :col-num="colNum"
      :margin="waterFlowMargin"
      :row-height="rowHeight"
      :is-draggable="isDraggable"
      :is-resizable="isResizable"
      ref="gridLayout"
      :layout.sync="layout"
      :style="{
        minHeight: gridLayoutMinH,
        marginLeft: -waterFlowMargin[0] + 'px',
        marginRight: -waterFlowMargin[0] + 'px'
      }"
      @layout-updated="layoutUpdatedEvent"
      @click.native="clickGridLayout"
      :class="isResizing ? 'isResizing' : ''"
      :transformScale="zoom"
      @layout-ready="layoutMountedEvent"
      @mousedown.stop.prevent
      @mouseup.native="isResizing = false"
    >
      <div class="empty-rect-tip" v-if="!layout || layout.length === 0">
        <p>从左侧工具栏拖拽添加模块</p>
      </div>
      <grid-item
        v-else
        v-for="(layoutGrid, index) in layout"
        :x="layoutGrid.x"
        :y="layoutGrid.y"
        :w="layoutGrid.w"
        :h="layoutGrid.h"
        :i="layoutGrid.i"
        :key="layoutGrid.i"
        :ref="layoutGrid.i"
        :minH="minH"
        :style="'z-index:'+(maxGridY - layoutGrid.y)"
        :class="[
          layoutGrid.i,
          gridDragOverId === layoutGrid.i ? 'grid-hover' : '',
          getHasFullRect(waterFlowLayouts[index].rects),
          activeGridId === layoutGrid.i && !ids.rect_id ? 'active' : '',
          gridMouseId === layoutGrid.i ? 'hover' : '',
          dragging ? 'dragging' : ''
        ]"
        @drop.native.stop="gridDropEvent($event, layoutGrid, index)"
        @dragover.native.prevent="dragoverEv($event, layoutGrid, index)"
        @dragleave.native.prevent="dragoverLeaveEv($event, layoutGrid)"
        @resize="resizeEvent(layoutGrid.i)"
        @move="moveEvent(layoutGrid.i)"
        @moved="movedEvent(layoutGrid.i)"
        @resized="resizedEvent(waterFlowLayouts[index].rects, layoutGrid.i)"
        @container-resized="containerResizedEvent"
        @click.native.stop="gridMouseUpEvent($event, layoutGrid.i)"
        @mousedown.native.stop="gridMouseClickEvent(layoutGrid.i)"
        @mouseenter.native.stop="gridMouseEnterEvent($event, layoutGrid.i)"
        @mouseleave.native.stop="gridMouseLeaveEvent($event, layoutGrid.i)"
        :drag-allow-from="'.handle-move'"
        :drag-ignore-from="'.vdr:not(.handle-move),.resize_handle,.dragBtn_inner,.custom-handle,.textInner>div,.thumbsSwiperBox,.swiper-3d-container'"
        @resizeEnter="resizeEnter(waterFlowLayouts[index].rects)"
        @resizeLeave="resizeLeave(waterFlowLayouts[index].rects)"
        @mouseup.native="isResizing = false"
      >
        <!-- 拖入提示-->
        <!--        <div v-if="gridDragOverId === layoutGrid.i && isBaseComponent" class="drag-tip">添加到布局</div>-->
        <div v-if="gridDragOverId === layoutGrid.i" class="drag-tip">添加到布局</div>
        <div class="new-btn-groups" v-show="!isResizing">
          <cx-tooltip class="set-groups" content="删除" placement="top-end">
            <span class="icon icon-portal-delete" @click="delClick(index)"></span>
          </cx-tooltip>
        </div>
        <div v-show="isResizing && gridResizingId === layoutGrid.i" class="size-popover">
          {{ "W: " + resizeWidth(layoutGrid.w) }}
          {{ "H: " + resizeHeight(layoutGrid.h) }}
        </div>
        <template >
          <span class="border-handle handle-tb"></span>
          <span class="border-handle handle-rb"></span>
          <span class="border-handle handle-bb"></span>
          <span class="border-handle handle-lb"></span>
        </template>
        <div class="grid-item-content" :key="layoutGrid.i" :data-i="layoutGrid.i" :pageLayoutId="pageLayoutId">
          <span class="icon handle-move"></span>
          <!--loading效果-->
          <div class="loading-wrap">
            <div class="loading-rect-box">
              <span class="icon icon-portal-loading1"></span>
              <p>模块加载中</p>
            </div>
          </div>
          <div
            class="empty-rect-tip"
            v-if="!waterFlowLayouts[index].rects || waterFlowLayouts[index].rects.length === 0"
          >
            <p>从左侧工具栏拖拽添加模块</p>
          </div>
          <template v-else>
            <VueDragResizable
              v-for="(rect, rectIndex) in waterFlowLayouts[index].rects"
              v-if="rect.options && isMounted"
              :isGridItem="true"
              :isGridResizing="isResizing && gridResizingId === layoutGrid.i"
              :key="rect.i + rectIndex"
              :class="[
                judgeIsFullRect(rect),
                `container_id_${id}-rect_id_${rect.rect_id}`,
                rect.active && !isElementInLayout ? 'active' : ''
              ]"
              :options="rect.options"
              :w="checkAndSetVal(rect.options, 'width', 'width', 20, { container_id: id, rect_id: rect.rect_id })"
              :h="checkAndSetVal(rect.options, 'height', 'height', 20, { container_id: id, rect_id: rect.rect_id })"
              :x="baseComponent.includes(rect.options.innerElement) ? rect.options.left : 0"
              :y="baseComponent.includes(rect.options.innerElement) ? rect.options.top : 0"
              :parentW="Number(getParentW(rect))"
              :parentH="Number(getParentH(rect))"
              :parent="true"
              :active="rect.active && !isElementInLayout"
              :draggable="getDraggable(rect)"
              :resizable="checkResizable(rect)"
              :z="rect.zIndex"
              :rectId="rect.rect_id"
              :containerId="id"
              :snapWithAdsorbent="true"
              :shape="rect.shape"
              :zoom="zoom"
              :isShowModuleHandles="true"
              :isWaterItem="true"
              @delGridItem="delGridItem(waterFlowLayouts[index].rects.length, index, layoutGrid.i)"
              v-on:dragging="draggingEv(arguments, id, rect.rect_id)"
              v-on:dragStop="dragStopEv(arguments, id, rect.rect_id)"
              v-on:activated="activateEv(id, rect.rect_id, rect.shape, index, layoutGrid.i)"
              v-on:deactivated="deactivateEv(id, rect.rect_id, rect.shape, index, layoutGrid.i)"
              v-on:resizing="changeSize($event, id, rect.rect_id, false, rect)"
              v-on:resizeStop="changeSize($event, id, rect.rect_id, true, rect)"
              :style="getSpecialStyle(rect)"
              :myId="getMyId({ rect_id: rect.rect_id, container_id: id })"
            >
              <div
                class="vdr_shade"
                @mouseenter.stop="vdrMouseenterEvent(rect.shape, layoutGrid.i)"
                @mouseleave.stop="vdrMouseLeaveEvent(rect.shape, layoutGrid.i)"
                :class="[rect.options.leftType === '%' || rect.options.topType === '%' ? 'no-drag' : '']"
                v-show="
                  isResizing ||
                  (!rect.active &&
                    rect.shape !== 'cxPageLayoutComponent' &&
                    (ids.rect_id !== rect.rect_id || ids.container_id !== id) &&
                    !$store.state.states.leftMenuDragStatus &&
                    !isBigScreenPreview()) ||
                  (complexComponents.includes(rect.shape || rect.innerElement) && !showRightToolbar)
                "
              ></div>
              <grid-cache-component
                :cache="isResizing || isDragging"
                :zoom="zoom"
                :isGridItem="true"
                :rect="rect"
                :active="rect.active && !isElementInLayout"
                :options="rect.options"
                :parentOptions="parentElement"
                :rectheight="Number(rect.height)"
                :myid="getMyId({ rect_id: rect.rect_id, container_id: id, elementInAutoLayoutId: rect.elementInAutoLayoutId })"
                :class="['rect']"
                :shape="rect.shape === 'emptyLayoutComponent' ? 'layoutComponent' : rect.shape"
              ></grid-cache-component>
            </VueDragResizable>
          </template>
        </div>
      </grid-item>
    </grid-layout>
  </div>
</template>
<script>
import { materialLoader } from "core/materialLoader"
import GridCacheComponent from "./gridContainer.js"
// import VueGridLayout from "vue-grid-layout"
import VueGridLayout from "./new-grid-layout.umd.min.js"
import VueDragResizable from "components/publicComponent/vueDragRiseable/vue-drag-resizable.vue"
import $ from "jquery"
import { _throttle, isExist } from "utils"
import componentMixIn from "./colsMixin"
import { deepCloneAndFreeze } from "utils/revork"
import { objectSize } from "../../../utils/event/animate"
export default {
  name: "waterFall",
  mixins: [componentMixIn],
  inject: ['isSelfModeValue', 'selfStageValue'],
  components: {
    GridCacheComponent,
    ...materialLoader.getAllRenderComponentsMixin(),
    GridLayout: VueGridLayout.GridLayout,
    GridItem: VueGridLayout.GridItem,
    VueDragResizable
  },
  props: {
    isNewVersion: [Boolean, undefined],
    inDocument: {
      type: String
    },
    zoom: {
      type: Number,
      default: 1
    },
    parentElement: {
      type: Object
    },
    baseComponent: {
      type: Array
    },
    id: {
      type: Number,
      default: 0
    },
    height: Number,
    options: undefined,
    myId: undefined,
    colNum: {
      type: Number,
      default: 48
    },
    rowHeight: {
      type: Number,
      default: 1
    },
    isDraggable: {
      type: Boolean,
      default: true
    },
    isResizable: {
      type: Boolean,
      default: true
    },
    cellData: Array,
    gridLayout: {
      default: () => [],
      required: true
    },
    currentPageLayoutId: [String, Number],
    // 这个实际拿到的是当前通栏的索引_布局id，不是真实的通栏id
    pageLayoutId: {
      required: true
    },
    waterFlowMargin: {
      required: true,
      default: function () {
        return [10, 10]
      }
    },
    forbidActive: {
      required: true,
      type: Boolean
    }
  },
  watch: {
    "waterFlowMargin.0": {
      // X轴的间距发生修改
      handler(newVal, oldVal) {
        this.$refs.gridLayout.resizeEvent()
      }
    },
    "ids.pageLayoutId"(newVal, oldVal) {
      if ((oldVal === null || typeof oldVal === "undefined") && newVal !== oldVal) {
        this.activeGridId = null
      }
    },
    gridLayout: {
      handler(newVal, oldVal) {
        this.layout = newVal
      }
    }
  },
  computed: {
    isSelfMode() {
      return this.isSelfModeValue ? this.isSelfModeValue() : false
    },
    selfStage() {
      return this.selfStageValue ? this.selfStageValue() : null
    },
    originStage() {
      if (this.isSelfMode) return this.selfStage
      return this.$store.state[this.request_prefix]
    },
    compareGridHeights() {
      const yArr = this.gridYMap
      const disCheckArr = []
      yArr.map((val, index) => {
        if (val === 0) {
          disCheckArr.push({
            y: 0,
            dis: [-1000, yArr[1] / 2]
          })
        } else if (index === yArr.length - 1) {
          disCheckArr.push({
            y: val,
            dis: [disCheckArr[index - 1].dis[1] + 1, 99999999]
          })
        } else {
          disCheckArr.push({
            y: val,
            dis: [disCheckArr[index - 1].dis[1] + 1, disCheckArr[index - 1].dis[1] + this.waterFlowMargin[1] + (yArr[index + 1] - val) / 2 + (val - yArr[index - 1]) / 2]
          })
        }
      })
      return disCheckArr
    },
    gridYMap() {
      return [...new Set(this.layout.map(item => {
        return item.y
      }))].sort((a, b) => a - b).concat(this.maxGridHeight)
      
    },
    maxGridHeight() {
      return this.gridLayout.map(item => item.y + item.h).sort((a, b) => {
        return b - a
      })[0]
    },
    maxGridY() {
      return this.layout.length ? (Math.max(...this.layout.map(item => item.y)) + 1) : 1
    },
    activeGridId: {
      get() {
        return this.$store.state.states.activeGridId
      },
      set(newVal) {
        this.$store.commit("states/changeActiveGridIdStatus", newVal)
      }
    },
    showGridHandle() {
      if (this.inDocument !== "header" && this.inDocument !== "footer") {
        return true
      }
      if (this.layout.find(item => item.i === this.activeGridId)) {
        return true
      }
      if (isExist(this.ids.rect_id) && this.cellData.find(cell => cell.rect_id === this.ids.rect_id)) {
        return true
      }
      if (this.ids.pageLayoutId == this.pageLayoutId.split("_")[0]) {
        return true
      }
      return false
    },
    getParentW() {
      // 当下面的元素宽高为百分比时需要获取父级宽高
      return function (rect) {
        const element = document.getElementsByClassName(`container_id_${this.id}-rect_id_${rect.rect_id}`)
        const parent = this.getTargetParent(element[0], [], "vue-grid-item")
        let width = parent[0] ? parent[0]?.getBoundingClientRect().width/ this.zoom : null
        return width
      }
    },
    getParentH() {
      // 当下面的元素宽高为百分比时需要获取父级宽高
      return function (rect) {
        const element = document.getElementsByClassName(`container_id_${this.id}-rect_id_${rect.rect_id}`)
        const parent = this.getTargetParent(element[0], [], "vue-grid-item")
        let height = parent[0] ? parent[0]?.getBoundingClientRect().height/ this.zoom : null
        return height
      }
    },
    gridLayoutMinH() {
      if (!this.layout || this.layout.length === 0) {
        return "500px"
      } else {
        return "20px"
      }
    },
    showRightToolbar: {
      get() {
        return this.$store.state.states.showRightToolbar
      },
      set(val) {
        this.$store.commit("states/changeShowRightToolbarStatus", val)
      }
    },
    showEditShape() {
      return this.$store.state.states.showEditShape || false
    },
    isElementInLayout() {
      if (this.ids.uid) {
        return true
      }
      if (this.ids.elementInLayoutId !== null && typeof this.ids.elementInLayoutId !== "undefined") {
        return true
      }
      if (this.ids.elementInSwiperId !== null && typeof this.ids.elementInSwiperId !== "undefined") {
        return true
      }
      return false
      // 下面这种写法 ids变化的时候 不一定会重新计算
      // return this.ids.hasOwnProperty("elementInLayoutId") || this.ids.hasOwnProperty("uid") || (this.ids.hasOwnProperty("elementInSwiperId") && this.ids.elementInSwiperId != undefined)
    },
    getDraggable() {
      return function (rect) {
        if (this.forbidActive) {
          return false
        }
        return this.baseComponent?.indexOf(rect.shape) > -1 ||
        // 特殊情况，自由布局组件，带“ListPageSearchComponentPlugin”插件的组件，作为基础组件处理
        rect.options?.pluginName?.indexOf("ListPageSearchComponentPlugin") > -1 ||
        // 自动布局中，所有组件都当做基础组件处理
        this.showRowColLayout
          ? rect.draggable
          : false
      }
    },
    getHasFullRect() {
      return function (rects) {
        if (!rects || rects.length === 0) {
          return false
        }
        let hasFullRect = false
        let hasFullRectActive = false
        let hasRectActive = false
        for (let i = 0; i < rects.length; i++) {
          if (this.baseComponent.indexOf(rects[i].shape) === -1) {
            hasFullRect = true
            hasFullRectActive = rects[i].active && !this.isElementInLayout ? true : false
            hasRectActive = rects[i].active ? true : false
            if (
              !hasRectActive &&
              this.ids &&
              !rects[i].active &&
              this.ids.rect_id === rects[i].rect_id &&
              this.ids.hasOwnProperty("container_id")
            ) {
              // 当激活复杂组件下的组件时
              let rect = this.getAttrById(this.originStage, this.ids)
              hasRectActive =
                rect?.isActive ||
                (this.ids.uid && !isExist(this.ids.elementInLayoutId)) ||
                isExist(this.ids.swiperContent_id) ||
                isExist(this.ids.directionIndexOther)
            }
            break
          } else {
            hasRectActive = rects[i].active ? true : false
            if (!hasRectActive && this.ids.hasOwnProperty("elementInAutoLayoutId")) {
              hasRectActive = true
            }
          }
        }
        let className = hasFullRect ? "no-border" : ""
        className += hasFullRectActive ? " grid-rect-active" : ""
        className += hasRectActive ? " grid-active" : "" // 用于控制复杂组件激活状态时的层级
        return className
      }
    },
    getSpecialStyle() {
      return function (rect) {
        // 自动布局内部为定位,所以padding需要放在外层
        // if (rect.shape === "cxAutoLayout") {
        //   let borderW = ""
        //   if (Array.isArray(rect.options.borderWidth)) {
        //     rect.options.borderWidth.forEach(item => [(borderW += ` ${item}px`)])
        //   } else {
        //     borderW += ` ${rect.options.borderWidth}px`
        //   }

        //   let padding = `${rect.options.padding}px`
        //   let boxShadow = `0 0 0 ${padding}   rgba(56, 154, 30, 0.4)  inset`
        //   if (!rect.options.textPaddingTypeFlag || rect.options.textPaddingTypeFlag === 2) {
        //     padding = ` ${rect.options.paddingTop}px  ${rect.options.paddingRight}px  ${rect.options.paddingBottom}px  ${rect.options.paddingLeft}px`
        //     boxShadow = `0 -${rect.options.paddingBottom}px 0 0   rgba(56, 154, 30, 0.4)  inset, -${rect.options.paddingRight}px 0 0 0    rgba(56, 154, 30, 0.4)   inset , ${rect.options.paddingLeft}px 0 0 0  rgba(56, 154, 30, 0.4)  inset, 0 ${rect.options.paddingTop}px 0 0   rgba(56, 154, 30, 0.4)  inset`
        //   }
        //   let margin = `${rect.options.margin}px`
        //   if (rect.options.marginTypeFlag === 2) {
        //     margin = ` ${rect.options.marginTop}px ${rect.options.marginRight}px ${rect.options.marginBottom}px ${rect.options.marginLeft}px`
        //   }
        //   return {
        //     // padding: padding,
        //     // boxShadow: rect.active ? boxShadow : undefined,
        //     // "border-top-left-radius": rect.options.borderTopLeftRadius + "px",
        //     // "border-top-right-radius": rect.options.borderTopRightRadius + "px",
        //     // "border-bottom-right-radius": rect.options.borderBottomRightRadius + "px",
        //     // "border-bottom-left-radius": rect.options.borderBottomLeftRadius + "px",
        //     // "border-style": rect.options.borderStyle,
        //     // "border-color": rect.options.borderIsThemeColor
        //     //   ? this.themeColor
        //     //   : rect.options.borderColor.color
        //     //   ? rect.options.borderColor.color
        //     //   : rect.options.borderColor,
        //     // "border-width": borderW
        //     margin: margin
        //   }
        // }
      }
    },
    ids() {
      return this.$store.state.states.activeID
    },
    judgeIsFullRect() {
      return function (rect) {
        const isPageLayoutComponent = rect.shape === "cxPageLayoutComponent" ? true : false
        let className =
          this.baseComponent?.indexOf(rect.shape) > -1 ||
          // 特殊情况，自由布局组件，带“ListPageSearchComponentPlugin”插件的组件，作为基础组件处理
          // 自动布局下的组件不需要充满 可自定义尺寸
          rect.options?.pluginName?.indexOf("ListPageSearchComponentPlugin") > -1 || this.showRowColLayout || this.layout?.options?.showMultipleLayout
          ? ""
          :  "is_full_rect handle-move"
        className += rect.options?.pluginName?.indexOf("dateFilterTablePlugin") > -1 ? " hoverIndexTop" : ""
        if (className === "is_full_rect") {
          // 充满的时候不显示尺寸和位置
          this.$changeOptionsEV(false, "resizable", false, null, {
            container_id: this.id,
            rect_id: rect.rect_id
          }, true)
          this.$changeOptionsEV(false, "draggable", false, null, {
            container_id: this.id,
            rect_id: rect.rect_id
          }, true)
        }
        return className
      }
    },
    // 判断当前格子下是否有激活组件
    hasActiveRect() {
      return param => {
        let flag = (param && param.some(it => it.active)) || false
        return flag
      }
    },
    waterFlowLayouts() {
      let tempLayouts = JSON.parse(JSON.stringify(this.gridLayout))
      this.cellData.forEach(cell => {
        let currLayout = tempLayouts.find(item => item.i === cell.i)
        if (currLayout) {
          if (!currLayout.rects) currLayout.rects = []
          if (!currLayout.rects.find(item => item.rect_id == cell.rect_id)) {
            currLayout.rects.push(cell)
          }
        } else {
          console.log("多出了不匹配的组件")
        }
      })
      return tempLayouts
    },
    pageLayoutWidth() {
      const pageLayoutList = this.originStage.page.pageLayoutList
      const pageLayoutIndex = this.pageLayoutId.split("_")[0]
      const options = pageLayoutList[this.isSelfMode ? 0 : pageLayoutIndex].options
      const pageWidth = this.originStage.page.pageWidth
      // 设置通栏的宽度
      let width
      if (options.isCustomWidth) {
        // 自定义宽度  包括之前的固定定位后的宽度
        width = options.widthType === "%" ? (options.width * 1920) / 100 : options.width
      } else if (this.request_prefix === "appStage") {
        width = 414 - options.padding[1] - options.padding[3]
      } else if (options.isFullPage) {
        // 充满或者移动端
        width = 1920 - options.padding[1] - options.padding[3]
      } else {
        // 跟随版心
        width = pageWidth
      }
      width = width || pageWidth
      return width
    },
    resizeWidth() {
      return function (w) {
        const colWidth = (this.pageLayoutWidth - this.waterFlowMargin[0] * (this.colNum + 1)) / this.colNum
        return Math.round(colWidth * w + Math.max(0, w - 1) * this.waterFlowMargin[0])
      }
    },
    resizeHeight() {
      return function (h) {
        return Math.round(this.rowHeight * h)
      }
    },
    showRowColLayout() {
      return this.layout?.options?.showRowColLayout
    }
  },
  data() {
    return {
      isBaseComponent: false,
      mouseDownId: undefined,
      gridResizingId: null,
      activeRectInPageLayoutComponent: true,
      layout: [],
      gridDragOverId: null,
      // activeGridId:undefined,
      dragType: "",
      isGridDragOvering: false,
      isDragging: false,
      isResizing: false,
      parentRect: null,
      DragPos: { x: null, y: null, w: 1, h: 1, i: null },
      isDragOrResize: false,
      wShapeMap: {
        cxImage: this.colNum / 4,
        cxText: this.colNum / 4,
        cxVideo: this.colNum / 4,
        cxGaphic: this.colNum,
        cxPageLayout: this.colNum
      },
      hShapeMap: {
        cxGaphic: 500,
        swiper: 500,
        cxIframe: 500,
        cxTable: 500,
        cxBar: 500,
        cxLine: 500,
        cxPie: 500,
        cxRadar: 500,
        cxCloud: 500,
        cxPageLayout: 500,
        cxSystemNav: 100,
        cxUserPortraits:100,
        loginComponent:100,
        cxText: 54,
        cxWeather: 50,
        cxDate: 40,
        cxSwiper3D: 450
      },
      complexComponents: ["emptyLayoutComponent", "swiperComponent", "layoutComponent"],
      minH: 3, // 默认情况间距为10，步长为10，此时最小高度是50。 如果不满足，后面可按照动态的来
      gridMouseId: false,
      dragging: false,
      isMounted: false,
      delWaterFallDrid: false,
      myidCache: {},
      loadingType : ['cxGaphic','cxSystemText','cxSystemSearch','swiperComponent'],
      isDropOnGridItem: false ,   //判断是不是drop在具体的栅格上，如果是，此时不走addDragEnd，否则会造成添加两次组件
    }
  },
  created() {
    // 尝试针对旧版本的栅格数据进行热更新，更新为最新的栅格版本数据
    if (!this.isNewVersion) {
      const oldGridLayout = this.gridLayout.slice()
      let newGridLayout = []
      newGridLayout = oldGridLayout.map(item => {
        if (item.y === 0) {
          return {
            ...item,
            h: Math.round((10 * item.h + Math.max(0, item.h - 1) * this.waterFlowMargin[1]) / this.rowHeight)
          }
        } else {
          // 非y === 0情况,
          return {
            ...item,
            y: Math.round((10 * item.y + (item.y - 1) * this.waterFlowMargin[1]) / this.rowHeight),
            h: Math.round((10 * item.h + Math.max(0, item.h - 1) * this.waterFlowMargin[1]) / this.rowHeight)
          }
        }
      })
      this.$changeOptionsEV(newGridLayout, "gridLayout", false, "", {
        container_id: this.id,
        pageLayoutId: this.pageLayoutId
      }, true)
      this.$changeOptionsEV(true, "isNewVersion", false, "", {
        container_id: this.id,
        pageLayoutId: this.pageLayoutId
      }, true)
    }
  },
  mounted() {
    console.log("baseComponent",this.baseComponent)
    const self = this
    // this.layoyt= this.gridLayout? JSON.parse(JSON.stringify(this.gridLayout)) : []
    this.layout = this.gridLayout || []
    this.cancleGridActive()
    this.$eventBus.$on("addDragEnd",async e => {
      const parentRect = self.$refs?.container?.getBoundingClientRect()
      if (!parentRect) return
      let isGridDragOver = sessionStorage.getItem("isGridDragOver")
      if (isGridDragOver) {
        this.$refs.gridLayout.isDragging = false
        this.layout = this.layout.filter(obj => obj.i !== "drop")
        return
      }
      const inGrid = e.x > parentRect.left && e.x < parentRect.right && e.y > parentRect.top && e.y < parentRect.bottom
      if (!this.isDropOnGridItem && ((inGrid && this.DragPos.x !== null) || this.canAdd)) {
        if (this.dragType === "cxPageLayout") {
          this.divideLayout(e.options.options.type,this.DragPos.y)
          this.addHistory()
        } else {
          const i = this.uuid.v1()
          let realHeight = this.hShapeMap[this.dragType] || 500
          if(this.baseComponent.indexOf(this.dragType) > -1){
            let dragRectHeight = parseInt(localStorage.getItem("dragRectHeight"))
            realHeight = dragRectHeight ? dragRectHeight+20 : realHeight
          }
          if (this.layout[this.layout.length - 1].i === "drop") {
            this.layout.splice(this.layout.length - 1, 1, { ...this.layout[this.layout.length - 1], i: i, h: realHeight })
          }
          this.addHistory()
          this.$emit("addNewRect", {
            i: i,
            addOptions: e.options,
            e: e.e,
            isNewGrid: true,
            isOuterAdd: this.canAdd ? true : false
          })
          this.$refs.gridLayout.isDragging = false
          this.activeGridId = null
          let dragType = localStorage.getItem("dragType")
          this.$nextTick(()=>{
            if(this.loadingType.indexOf(dragType)>-1){
              // 添加loading效果
              sessionStorage.setItem("isAddNewRect",true)
              let newGrid = this.$refs[i] && this.$refs[i][0]?.$el?.getElementsByClassName("loading-wrap")[0]
              // newGrid?.setAttribute("isLoading",true)
              newGrid?.classList.add("loading-newRect")
            }
          })
          this.canAdd && (this.canAdd = false)
        }
      } else {
        this.$refs.gridLayout.dragEvent("dragend", "drop", this.DragPos.x, this.DragPos.y, 1, 1)
        this.layout = this.layout.filter(obj => obj.i !== "drop")
      }
      this.isDropOnGridItem = false
      this.isDragging = false
    })
    document.addEventListener("keydown", this.keyPressEvent)
    this.$eventBus.$on(`del-waterFall-grid`, data => {
      let isHandle= sessionStorage.getItem("delWaterFallGrid") ? false : true
      if (this.baseComponent.indexOf(data.shape) === -1  && !isHandle) {
        // 此时删除了充满组件，和栅格一起删除
        let index = this.layout.findIndex(item => item.i === data.gridId)
        if (typeof index !== "undefined" && index > -1) {
          let len = this.waterFlowLayouts[index].rects.length
          this.delGridItem(len, index, data.gridId, true)
        }
      }
    })
    this.$eventBus.onlyOn('outer-grid-dragover', this.currentPageLayoutId, data => {
      console.log('接收到gragouterover事件:', this.pageLayoutId, data.key)
      this.handleOuterDragover(data)
    })
    this.$eventBus.onlyOn('outer-grid-dragover-add', this.currentPageLayoutId, data => {
      this.handleOuterDragAdd(data)
    })
    this.$eventBus.onlyOn('outer-grid-cancel', this.currentPageLayoutId, data => {
      console.log('接收到grag-cancel事件:')
      this.layout = this.layout.filter(obj => obj.i !== "drop")
      const placeholderItem = this.$refs.container?.querySelector('.vue-grid-placeholder')
      placeholderItem && (placeholderItem.style.display = 'none')
    })
  },
  methods: {
    getYByPosition(offsetY) {
      return (this.compareGridHeights.find(item => {
        return item.dis[0] < offsetY && item.dis[1] >= offsetY
      })?.y) || 0
    },  
    getMyId(myid) {
      const {container_id, rect_id} = myid
      if (this.myidCache[container_id + '-' + rect_id]) {
        return this.myidCache[container_id + '-' + rect_id]
      } else {
        this.myidCache[container_id + '-' + rect_id] = {
          container_id,
          rect_id
        }
        return this.myidCache[container_id + '-' + rect_id]
      }
    },
    delGridItem(len, index, itemKey, ids) {
      if(len > 1){
        // 此处删除组件
        let _ids = {
          container_id: ids.container_id,
          rect_id: ids.rect_id
        }
        this.$addHistory({
          type: "delete",
          stateType: "deleteElement",
          payload: _ids
        })
        this.$store.dispatch(this.request_prefix + "/deleteElement", _ids)
        return
      }
      this.delLayout(index)
    },
    handleResizing(status) {
      if (status) {
        sessionStorage.setItem("isGridResizing", true)
      } else {
        sessionStorage.removeItem("isGridResizing")
      }
    },
    keyPressEvent(e) {
      let key = window.event.keyCode
      if (key !== 46 || !this.activeGridId) {
        return
      }
      let index = this.waterFlowLayouts.findIndex(layout => layout.i === this.activeGridId)
      if (index === -1) {
        return
      }
      if (this.ids && this.ids.rect_id !== null && typeof this.ids.rect_id !== "undefined") {
        // 此时激活了组件，只做组件的删除
        return
      }
      this.delClick(index)
    },
    cancleGridActive() {
      // window.addEventListener("click", () => {
      //   this.activeGridId = null
      // })
    },
    checkResizable(rect) {
      if (this.showRowColLayout || rect.shape === "cxAutoLayout") {// 自动布局中
        return true
      }
      if (this.judgeIsFullRect(rect)?.includes("is_full_rect")) {
        return false
      }
      let widthType = rect.options.hasOwnProperty("widthType") ? rect.options.widthType : "px"
      let heightType = rect.options.hasOwnProperty("heightType") ? rect.options.heightType : "px"
      // if (widthType !== "px" && heightType !== "px") {
      //   return false
      // }
      return rect.resizable
    },
    getTargetParent(e, res = [], className) {
      const parentNode = e?.parentNode
      let parentName = className ? className : "layout-cell-container"
      if (parentNode && parentNode.classList) {
        let elClasslist = parentNode.classList
        if ([].find.call(elClasslist, it => it === "myContainer")) {
          return []
        } else if ([].find.call(elClasslist, it => it === parentName)) {
          res.push(parentNode)
        }
        if (res.length > 0) {
          return res
        } else {
          return this.getTargetParent(parentNode, res, className)
        }
      } else {
        return res
      }
    },
    // 获取鼠标在当前元素上的索引
    getInsertIndex(e) {
      let _this = this
      let top = Number(e.offsetY) //鼠标在当前元素上的位置
      let left = Number(e.offsetX)
      let _index = 0
      let targetPosition = e.target.getBoundingClientRect() // 当前元素位置
      let parentNode = this.getTargetParent(e.target, [])
      let targetVdr = this.getTargetParent(e.target, [], "vdr") // 获取当前vdr元素
      // if (this.startParent && this.startParent[0] !== parentNode[0]) { // 如果父级元素不同跨层级了禁止拖拽
      //   parentNode[0] = this.startParent[0] // 父级等于开始拖拽的父级
      //   if (this.getTargetParent(targetVdr[0])[0] !== this.startParent[0]) {
      //     targetVdr = this.getTargetParent(targetVdr[0],[],'vdr') // 目标元素取当前元素的父级
      //   }
      // }
      if (parentNode.length === 0) {
        // 鼠标移到外层时
        // _index = _this.cellData.length
        return -1
      }
      let allChild = parentNode[0].children
      if (!allChild) return -1
      for (var i = 0; i < allChild.length; i++) {
        if (allChild[i] === targetVdr[0]) {
          _index = i
          break
        }
      }
      // if (_this.layout?.options?.rowColDirection === "vertical") {
      //   //垂直方向排列
      //   _index = top / targetPosition.height < 0.5 ? _index : _index + 1 //超过元素高度一半显示在下方，否则显示在上方
      // }
      // if (_this.layout?.options?.rowColDirection === "horizon") {
      //   //水平方向排列
      //   _index = left / targetPosition.width < 0.5 ? _index : _index + 1 // 超过元素宽度一半显示在后方，否则显示在前方
      // }
      return _index + 1
    },
    dragStopEv(arr, id, index) {
      let newRect = arr[0]
      const attr = this.getRectAttribute.call(this, {
        container_id: id,
        rect_id: index
      }).options
      const [oL, oT] = [attr.left, attr.top]
      const [nL, nT] = [newRect.left, newRect.top]
      let insertIndex = this.getInsertIndex(arr[4])
      if (this.showRowColLayout && (oL !== nL || oT !== nT || this.dragExecute === false)) {
        if (insertIndex < 0) return
        let activeIndex = this.cellData.findIndex(item => item.rect_id === index)
        this.cellRect.splice(activeIndex, 1) // 删除当前拖拽元素
        this.cellRect.splice(insertIndex - 1, 0, index) //插入到鼠标放到的元素位置
        this.activateEv(id, index, attr.innerElement, activeIndex, id)
        this.insertIndex = null
      }
      this.dragging = false
      if (oL !== nL || oT !== nT) {
        this.dragExecute = false
        this.$store.commit("states/changeDragMode", true)
        this.dragExecute = true
        const componentIds = { container_id: id, rect_id: index }
        this.$store.commit("states/changeDragMode", false)
        const rulers = JSON.parse(localStorage.getItem("rulers"))
        if (Array.isArray(rulers)) {
          rulers.forEach(item => {
            if (item.type == "h") {
              if (Math.abs(newRect.top - item.site) < 10) {
                newRect.top = item.site
              }
              if (Math.abs(newRect.top + newRect.height - item.site) < 10) {
                newRect.top = item.site - newRect.height
              }
            }
            if (item.type == "v") {
              if (Math.abs(newRect.left - item.site) < 10) {
                newRect.left = item.site
              }
              if (Math.abs(newRect.left + newRect.width - item.site) < 10) {
                newRect.left = item.site - newRect.width
              }
            }
          })
        }
        this.$store.dispatch(this.request_prefix + "/setTop", {
          container_id: id,
          rect_id: index,
          top: newRect.top
        })
        this.$store.dispatch(this.request_prefix + "/setLeft", {
          container_id: id,
          rect_id: index,
          left: newRect.left
        })
        this.$store.commit("states/changeDraggingStatus", false)
      }
    },
    draggingEv(arr, id, index) {
      let newRect = arr[0]
      if (this.dragExecute) {
        if (!this.$store.state.states.dragStatus) this.$store.commit("states/changeDraggingStatus", true)
        const attr = this.getRectAttribute.call(this, this.ids).options
        const [oL, oT] = [attr.left, attr.top]
        const [nL, nT] = [newRect.left, newRect.top]
        if (oL !== nL || oT !== nT) {
          this.dragExecute = false
          this.$store.commit("states/changeDragMode", true)
        }
      }
      this.dragging = true
      if (this.showRowColLayout) {
        this.insertIndex = this.getInsertIndex(arr[4])
      }
    },
    changeSize: _throttle(function (newRect, id, index, isResizeStop, rect) {
      this.$store.commit(this.request_prefix + "/CHANGE_DRAGGABLE", { container_id: id, rect_id: index, flag: false })
      if (!newRect.isQuickSite) {
        this.$store.dispatch(this.request_prefix + "/setLeft", {
          container_id: id,
          rect_id: index,
          left: newRect.left
        })
        this.$store.dispatch(this.request_prefix + "/setTop", {
          container_id: id,
          rect_id: index,
          top: newRect.top
        })
      }
      if (
        rect.shape !== "cxAutoLayout" ||
        (rect.shape === "cxAutoLayout" && (rect.options.widthType === "px" || !rect.options.widthType))
      ) {
        this.$store.dispatch(this.request_prefix + "/setWidth", {
          container_id: id,
          rect_id: index,
          width: newRect.width
        })
      }
      if (
        rect.shape !== "cxAutoLayout" ||
        (rect.shape === "cxAutoLayout" && (rect.options.heightType === "px" || !rect.options.heightType))
      ) {
        this.$store.dispatch(this.request_prefix + "/setHeight", {
          container_id: id,
          rect_id: index,
          height: newRect.height
        })
      }

      if (isResizeStop) {
        this.$store.commit(this.request_prefix + "/CHANGE_DRAGGABLE", { container_id: id, rect_id: index, flag: true })
      }
    }, 10),
    divideLayout(type,y) {
      // let layout = JSON.parse(JSON.stringify(this.layout[this.layout.length - 1]))
      // type值 1为1  2为1:1  9为1:1:1
      // let y = 0
      if (this.layout.length>0 && this.layout[this.layout.length - 1].i === "drop") {
        // this.layout.splice(this.layout.length - 1, 1, { ...this.layout[this.layout.length - 1], h:500, i: this.uuid.v1() })
        y = this.layout[this.layout.length - 1].y
        this.layout.splice(this.layout.length - 1, 1)
      }else{
        // this.layout.splice(this.layout.length - 1, 0, { ...this.layout[this.layout.length - 1], w: this.colNum,h:500, i: this.uuid.v1() })
        // y = this.layout[this.layout.length - 1].y
      }
      const h = this.hShapeMap.cxPageLayout / this.rowHeight
      console.log("h", h)
      switch (type) {
        case 1:
          if(this.layout.length >0){
            this.layout.push({ ...this.layout[this.layout.length - 1],w: this.colNum, y:y,h:500, i: this.uuid.v1() })
          }else{
            this.layout.push({
              w: this.colNum,
              h: 500,
              x: 0,
              y: 0,
              i: this.uuid.v1()
            })
          }
          break
        case 2:
          this.layout.splice(
            this.layout.length - 1,
            0,
            {
              w: this.colNum / 2,
              h: h,
              x: 0,
              y: y,
              i: this.uuid.v1()
            },
            {
              w: this.colNum / 2,
              h: h,
              x: this.colNum / 2,
              y: y,
              i: this.uuid.v1()
            }
          )
          break
        case 9:
          this.layout.splice(
            this.layout.length - 1,
            0,
            {
              w: this.colNum / 3,
              h: h,
              x: 0,
              y: y,
              i: this.uuid.v1()
            },
            {
              w: this.colNum / 3,
              h: h,
              x: this.colNum / 3,
              y: y,
              i: this.uuid.v1()
            },
            {
              w: this.colNum / 3,
              h: h,
              x: (this.colNum * 2) / 3,
              y: y,
              i: this.uuid.v1()
            }
          )
          break
        default:
      }
      this.$refs.gridLayout.isDragging = false
    },
    delClick(index) {
      this.$confirm("确认删除吗？", "", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        showClose: false,
        dangerouslyUseHTMLString: "<p>确认删除吗？</p>",
        iconClass: "bigScreen_confirm_icon el-icon-warning",
        cancelButtonClass: "bigScreen_confirm_cancel_button",
        confirmButtonClass: "bigScreen_confirm_button",
        customClass: "bigScreen_confirm custom_warning_dialog"
      })
        .then(() => {
          this.delLayout(index)
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            type: "success",
            message: "删除成功"
          })
        })
        .catch(() => {})
    },
    // 删除布局块
    delLayout(index, hasDelRect) {
      const before = this.getQuickShot()
      let layout = this.waterFlowLayouts[index]
      let pageLayoutList = JSON.parse(JSON.stringify(this.originStage.page.pageLayoutList))
      const ids = this.pageLayoutId.split("_")
      const rect = pageLayoutList[ids[0]]
      layout.rectIds = (layout.rects || []).map(rect => rect.rect_id)
      if(this.waterFlowLayouts.length === 1 && index === 0){
        this.$addHistory({
          type: "delete",
          stateType: "deletePageLayout",
          payload: {
            container_id: 0,
            pageLayoutId: pageLayoutList[ids[0]].id,
          }
        })
        // 最后一个栅格，测试要删除通栏
        if (!hasDelRect) {
          layout.rectIds.forEach(rect_id => {
            // 删除组件
            this.$store.dispatch(this.request_prefix + "/deleteElement", {
              container_id: this.id,
              rect_id: rect_id
            })
          })
        }
        pageLayoutList.splice(ids[0], 1)
        this.$store.dispatch(this.request_prefix + "/changePageLayout", { pageLayoutList: pageLayoutList })
        // 删除通栏之后将激活项转移到前面一个通栏上
        let activeIndex = ids[0] > 0 ? ids[0] - 1 : ids[0] + 1
        // this.$store.commit("states/changeActiveID", null)
        // this.$store.commit("states/changeElementType", null)
        this.$store.commit("states/changeActiveID", { container_id: this.id, pageLayoutId: activeIndex })
        this.$store.commit("states/changeElementType", "cxPageLayout")
        return
      }else{
        this.layout.splice(index, 1)
      }
      const newData = this.getQuickShot()
      this.$addHistory({
        type: "update",
        stateType: "updatePageLayout",
        payload: {
          container_id: this.ids.container_id,
          pageLayoutId: rect.id,
          deleteCell: layout
        },
        before,
        data: newData
      })
      if (!hasDelRect) {
        // 快捷删除组件在其他地方已经执行了，所以此处无需再删
        layout.rectIds.forEach(rect_id => {
          // 删除组件
          this.$store.dispatch(this.request_prefix + "/deleteElement", {
            container_id: this.id,
            rect_id: rect_id
          })
        })
      }
      // layout.rectIds.forEach(rect_id => {
      //   // 删除组件
      //   this.$store.dispatch(this.request_prefix + "/deleteElement", {
      //     container_id: this.id,
      //     rect_id: rect_id
      //   })
      // })
    },
    clickGridLayout() {
      if (this.inDocument === "header" || this.inDocument === "footer") {
        return
      }
      if (this.showEditShape) {
        return
      }
      if (this.isDragging || this.isResizing) {
        return
      }
      this.activeGridId = null
    },
    layoutUpdatedEvent() {
      if (this.isSelfMode) return
      this.updateLayout()
      this.updateLayoutHeight()
    },
    layoutMountedEvent() {
      console.log("====")
      setTimeout(() => {
        this.isMounted = true
        !this.isSelfMode && this.updateLayoutHeight()
      }, 100)
    },
    containerResizedEvent() {
      this.isDragging = false
    },
    gridMouseClickEvent(gridId) {
      this.before = this.getQuickShot()
      this.mouseDownId = gridId
    },
    gridMouseLeaveEvent(el, gridId) {
      sessionStorage.removeItem("gridMouseEnter")
      if (this.isResizing || this.showEditShape) return
      this.gridDragOverId = null
      $(".vue-grid-item").removeClass("grid-hover")
      $(`.${gridId}`).removeClass("grid-hover")
      $(`.${gridId}`).removeClass("hover")
      $(el.target).parents(".layout-container").removeClass("parent-unActive")
    },
    gridMouseEnterEvent(el, gridId) {
      sessionStorage.setItem("gridMouseEnter", true)
      if (this.isResizing || this.showEditShape) return
      // let isTopLevel = $($(this.$el).parents(".page-layout-wrapper")[0]).attr("data-level")
      // $(".page-layout-wrapper[data-level='top-level']").removeAttr("data-level")
      $(".layout-col.zIndex999").removeClass("zIndex999")
      $(this.$el).parents(".layout-col").addClass("zIndex999")
      // if (isTopLevel) {//之前有才重新加上 没有就不加
      //   $($(this.$el).parents(".page-layout-wrapper")[0]).attr("data-level", "top-level")
      // }
      $(`.${gridId}`).addClass("hover")
      $(`.${gridId}`).addClass("grid-hover")
      $(el.target).parents(".layout-container").addClass("parent-unActive")
    },
    gridMouseUpEvent(event, gridId) {
      // if(this.inDocument === 'header' || this.inDocument === "footer" || this.showEditShape){
      if (this.showEditShape) {
        // 头部需要一直处于聚焦状态
        return
      }
      if (this.mouseDownId !== gridId) {
        return
      }
      this.mouseDownId = null
      if (event.target.classList.contains("size-control") || event.target.classList.contains("position-control")) return
      if (this.isDragOrResize) {
        this.isDragOrResize = false
        return
      }
      this.gridResizingId = null
      this.activeGridId = gridId
      this.clearActive()
      $(".page-layout-wrapper[data-level='top-level']").removeAttr("data-level")
      $($(this.$el).parents(".page-layout-wrapper")[0]).attr("data-level", "top-level")
      this.$nextTick(() => {
        // 选中通栏时点击会给通栏添加一个悬浮态 需要取消
        $($(this.$el).parents(".page-layout-wrapper.hover-active"))?.removeClass("hover-active")
      })
    },
    clearActive() {
      let oldIds = JSON.parse(JSON.stringify(this.ids))
      if (isExist(oldIds.elementInAutoLayoutId)) {
        // this.$store.dispatch(this.request_prefix + "/changeElementInAutoLayoutUnActive", oldIds)
        this.clearAutoLayoutElementActive()
      }
      this.$store.dispatch(this.request_prefix + "/unsetActive", {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id
      })
      this.$store.commit("states/changeActiveID", {
        container_id: 0
      })
      // this.$store.commit("states/changeElementType", null)
      this.$store.commit("states/changeElementType", "grid")
      this.$store.commit("states/changeToolBarStatus", true)
      this.$store.commit("states/changeAlignHelperStatus", false)
      this.$store.commit("states/changeShowRightToolbarStatus", true)
    },
    dragoverEv(e, layoutGrid, index) {
      if (this.isGridDragOvering) {
        return
      }
      this.isGridDragOvering = true
      if (!this) return
      // 暂定一个栅格里只有一个组件
      if (layoutGrid.i === "drop") {
        return
      }
      let dragType = localStorage.getItem("dragType")
      let hasFullRect = false
      if (dragType === "cxPageLayout") return
      if (this?.baseComponent?.indexOf(dragType) === -1) {
        this.isBaseComponent = false
        if (this.waterFlowLayouts[index].rects) {
          for (let k = 0; k < this.waterFlowLayouts[index].rects.length; k++) {
            let shape = this.waterFlowLayouts[index].rects[k].shape
            if (this.baseComponent.indexOf(shape) === -1) {
              hasFullRect = true
              break
            }
          }
        }
      } else {
        this.isBaseComponent = true
      }
      if (hasFullRect) return
      this.gridDragOverId = layoutGrid.i
      sessionStorage.setItem("isGridDragOver", "true")
      this.$refs.gridLayout.isDragging = false
      this.layout = this.layout.filter(item => item.i !== "drop")
    },
    dragoverLeaveEv(e, rect) {
      this.isGridDragOvering = false
      this.gridDragOverId = undefined
      sessionStorage.removeItem("isGridDragOver")
    },
    gridDropEvent(e, layoutGrid, index) {
      this.$refs.gridLayout.isDragging = false
      this.layout = this.layout.filter(obj => obj.i !== "drop")
      this.$el.getElementsByClassName("vue-grid-placeholder")[0].style.display="none"

      this.isDropOnGridItem = true
      sessionStorage.removeItem("isGridDragOver")
      this.isGridDragOvering = false
      this.gridDragOverId = undefined
      this.gridResizingId = null
      this.activeGridId = layoutGrid.i
      // 暂定一个栅格里只有一个组件
      let hasFullRect = false
      let rectAttr = e.dataTransfer.getData("rectAttribute")
      if (!rectAttr || rectAttr.length === 0 || rectAttr === "undefined"  || !JSON.parse(rectAttr).shape) {
        rectAttr = localStorage.getItem('dragTypeData')
      }
      if (rectAttr && rectAttr !== "undefined") {
        rectAttr = JSON.parse(rectAttr)
        if (this.baseComponent.indexOf(rectAttr.shape) === -1) {
          hasFullRect = this.judgeFullRect(index)
        }
      }else{
        hasFullRect = this.judgeFullRect(index)
      }
      if (hasFullRect) return
      let dragType = localStorage.getItem("dragType")
      if(this.loadingType.indexOf(dragType)>-1){
        // 添加loading效果
        sessionStorage.setItem("isAddNewRect",true)
        e.target.parentNode.getElementsByClassName("loading-wrap")[0].classList.add("loading-newRect")
        // e.target.parentNode?.setAttribute("isLoading",true)
      }
      // e.target容器取到被重叠的基础组件导致计算错误
      let targetPosition = e.currentTarget.getBoundingClientRect()
      this.$emit("addNewRect", {
        i: layoutGrid.i,
        addOptions: rectAttr || undefined,
        e: e,
        parentH: targetPosition.height,
        parentW: targetPosition.width
      })
      this.activeGridId = null
      // 内部新增组件了，则通知外部通栏取消其提示状态
      this.$eventBus.onlyEmit('cancelDragover', this.currentPageLayoutId)
      this.$nextTick(() => {
        // 添加组件时会给选中的通栏添加一个悬浮态 需要取消
        $($(this.$el).parents(".page-layout-wrapper.hover-active"))?.removeClass("hover-active")
      })
    },
    judgeFullRect(index){
      let hasFullRect = false
      // 新增的充满组件默认zIndex是2
      const newRectIndex = 2
      this.waterFlowLayouts[index].rects?.forEach(rect=>{
        if(rect.options.zIndex <= newRectIndex){
          this.$changeOptionsEV(rect.options.zIndex + newRectIndex +1  , "zIndex", false,null, {
            container_id: this.id,
            rect_id: rect.rect_id
          },true)
        }
      })
      if (this.waterFlowLayouts[index].rects) {
        for (let k = 0; k < this.waterFlowLayouts[index].rects.length; k++) {
          let shape = this.waterFlowLayouts[index].rects[k].shape
          if (this.baseComponent.indexOf(shape) === -1) {
            hasFullRect = true
            break
          }
        }
      }
      return hasFullRect
    },
    resizeEvent(id) {
      this.isDragging = true
      console.log("resizing设置为true")
      this.isResizing = true
      this.isDragOrResize = true
      this.gridResizingId = id
      this.handleResizing(true)
      const placeholderItem = this.$refs.container.querySelector('.vue-grid-placeholder')
      placeholderItem && (placeholderItem.style.opacity = 1)
    },
    moveEvent(id) {
      this.isDragging = true
      this.isDragOrResize = true
      $(`.${id}`).addClass("grid-hover")
      console.log("移动中", id)
      const placeholderItem = this.$refs.container.querySelector('.vue-grid-placeholder')
      placeholderItem && (placeholderItem.style.opacity = 1)
    },
    movedEvent: function (i, newX, newY) {
      this.gridDragOverId = null
      $(`.vue-grid-item`).removeClass("grid-hover")
      // if(this.inDocument === 'header' || this.inDocument === "footer"){
      //   // 头部需要一直处于聚焦状态
      //   return
      // }
      this.activeGridId = i
      this.gridResizingId = null
      // this.clearActive()
      this.$nextTick(() => {
        // 选中通栏时点击会给通栏添加一个悬浮态 需要取消
        $($(this.$el).parents(".page-layout-wrapper.hover-active"))?.removeClass("hover-active")
      })
      this.isDragging = false
      this.isResizing = false
      this.addHistory()
    },
    //单元格调整大小后的事件
    resizedEvent: function (rects, id) {
      rects = rects || []
      this.handleResizing(false)
      this.gridResizingId = null
      // 如果栅格中包含非基础组件，则激活非基础组件
      let fullRectIndex = rects.findIndex(rect => this.baseComponent.indexOf(rect.shape) === -1)
      setTimeout(() => {
        if (fullRectIndex > -1) {
          let rect = rects[fullRectIndex]
          this.activateEv(this.id, rect.rect_id, rect.shape, fullRectIndex, id)
        } else {
          // if(this.inDocument === 'header' || this.inDocument === "footer"){
          //   // 头部需要一直处于聚焦状态
          //   return
          // }
          this.activeGridId = id
          this.clearActive()
          this.$nextTick(() => {
            // 选中通栏时点击会给通栏添加一个悬浮态 需要取消
            $($(this.$el).parents(".page-layout-wrapper.hover-active"))?.removeClass("hover-active")
          })
        }
        this.isResizing = false
        this.isDragging = false
      }, 100)
      this.addHistory()
      console.log("resizing设置为false")
    },
    updateLayout() {
      this.$changeOptionsEV(this.layout, "gridLayout", false, "", {
        container_id: this.id,
        pageLayoutId: this.pageLayoutId
      }, true)
      
    },
    updateLayoutHeight() {
      const cellHeight = Math.max(...(this?.$refs?.gridLayout?.layoutLevels || []).map(item => {
        return item.y + item.h + item.level * this.waterFlowMargin[1]
      }))
      this.$changeOptionsEV(cellHeight, "gridLayoutHeight", false, "", {
        container_id: this.id,
        pageLayoutId: this.pageLayoutId
      }, true)
    },
    checkAndSetVal(opt, key, optname, val, ids) {
      if (!opt) return ""
      if (this.showRowColLayout) {// 拖入自动布局下的组件不需要偏移值
        if (key === "left" || key === "top") {
          return 0
        }
      }
      //兼容为NaN或没有的数值数据
      if (!opt.hasOwnProperty(key) || opt[key] !== opt[key] || opt[key] === null || opt[key] === undefined) {
        this.$changeOptionsEV(val, optname, false, null, ids)
        return val
      } else {
        return opt[key]
      }
    },
    addNewCell(cellData) {
      this.layout = this.layout.filter(obj => obj.i !== "drop")
      this.layout.push(cellData)
      this.$refs.gridLayout.dragEvent("dragend", this.DragPos.i, this.DragPos.x, this.DragPos.y, 1, 1)
      try {
        this.$refs.gridLayout.$children[this.layout.length].$refs.item.style.display = "block"
      } catch {}
    },
    // 判断是否是从左侧菜单栏拖入时的新增动作
    checkIsAddDragging() {
      return sessionStorage.getItem("isDragging")
    },
    async handleNewRectComponent(rectAttrString) {
      let rectAttr = rectAttrString
      rectAttr = JSON.parse(rectAttr)
      return rectAttr
    },
    handleDragOver: _throttle(function (e) {
      const dropOverCellComponent = sessionStorage.getItem("dropOverCellComponent")
      const dropOverCellComponentShape = sessionStorage.getItem("dropOverCellComponentShape")
      console.log("dropOverCellComponent", dropOverCellComponent)
      if (
        dropOverCellComponent &&
        dropOverCellComponentShape !== "cxPageLayout" &&
        dropOverCellComponentShape !== "cxPageLayoutComponent"
      ) {
        let index = this.layout.findIndex(item => item.i === "drop")
        if (index !== -1) {
          this.layout.splice(index, 1)
        }
        return
      }
      let isGridDragOver = sessionStorage.getItem("isGridDragOver")
      if (isGridDragOver) return
      if (!this.isDragging && !this.checkIsAddDragging()) return
      if (!this.isDragging) {
        this.parentRect = this.$refs.container.getBoundingClientRect()
      }
      if (!this.parentRect) return
      // const baseComponentShapes = ['cxText', 'cxButton', 'imageComponent', 'cxAudio', 'cxVideo', 'cxIcon']
      const shape = localStorage.getItem("dragType")
      // if (baseComponentShapes.includes(shape)) return
      this.isDragging = true
      let offsetX = e.clientX - this.parentRect.left
      let offsetY = e.clientY - this.parentRect.top
      console.log('内部滚动的offsetY值是', offsetY)
      let index = this.layout.findIndex(item => item.i === "drop")
      const w = this.colNum
      let defaultH = this.hShapeMap[shape] || 500
      if(this.baseComponent.indexOf(shape) > -1){
        let dragRectHeight = parseInt(localStorage.getItem("dragRectHeight"))
        defaultH = dragRectHeight ? dragRectHeight+20 : defaultH
      }
      const h = 20
      this.dragType = shape
      let showW = w
      if (index === -1) {
        this.DragPos.w = w
        this.DragPos.h = h
        const x = (this.layout.length * 2) % (this.colNum || 12)
        // const y = this.layout.length + (this.colNum || 12)
        const y = this.getYByPosition(offsetY)
        showW = shape === "cxPageLayout" ? this.colNum : w
        let newLayout = {
          w: showW,
          h,
          x,
          y,
          i: "drop"
        }
        this.before = this.getQuickShot()
        this.layout.push(newLayout)
      } else if (index !== -1) {
        let placeholderItem = null
        try {
          placeholderItem = this.$refs.gridLayout.$children[this.layout.length]
          placeholderItem && (placeholderItem.$refs.item.style.display = "none")
        } catch {}
        let el = this.$refs.gridLayout.$children[index]
        el.innerW = w

        e.dragging = { top: offsetY, left: offsetX }
        // let new_pos = el.calcXY(offsetY, offsetX)
        let new_pos = {x: 0, y: this.getYByPosition(offsetY)}
        console.log("new_pos",new_pos)
        this.$refs.gridLayout.dragEvent("dragstart", "drop", new_pos.x, new_pos.y, this.DragPos.h, this.DragPos.w)
        this.DragPos.i = String(index)
        this.DragPos.x = new_pos.x
        this.DragPos.y = new_pos.y
      }
    }, 150),
    handleOuterDragover: _throttle(function ({position, shape, key}) {
      // 如果从外部转到内部拖拽了，就不响应外部的dragover事件了
      console.log('this.isDragging', this.isDragging, 'this.isGridDragOvering', this.isGridDragOvering)
      if (this.isDragging || this.isGridDragOvering ) {
        return 
      } 
      this.dragType = shape
      console.log('当前通栏ids是', this.pageLayoutId)
      // 处理外部的dragover事件
      const { y: posY = 0, x: posX } = position
      let dropItem = this.gridLayout.find(item => item.i === "drop")
      let index = this.gridLayout.findIndex(item => item.i === "drop")
      let targetY = 0
      // let nextYIndex = 0
      // if (this.gridYMap.length > 0 && (posY > this.gridYMap[this.gridYMap.length - 1])) {
      //   nextYIndex = this.gridYMap.length - 1
      // } else {
      //   nextYIndex = this.gridYMap.findIndex(val => val > posY)
      // }
      // if (posY <= ((this.gridYMap[nextYIndex] || 0) + (this.gridYMap[nextYIndex - 1] || 0)) / 2) {
      //   targetY = this.gridYMap[nextYIndex - 1] || 0
      // } else {
      //   if (dropItem?.y + dropItem?.h === this.gridYMap[this.gridYMap.length - 1]) {
      //     targetY = dropItem.y
      //   } else {
      //     targetY = this.gridYMap[nextYIndex] || 0
      //   }
      // }
      targetY = (this.compareGridHeights.find(item => {
        return item.dis[0] < posY && item.dis[1] >= posY
      })?.y) || 0
      console.log('targetY的值是', posY, targetY, JSON.stringify(this.compareGridHeights))
      const placeholderItem = this.$refs.container.querySelector('.vue-grid-placeholder')
      placeholderItem && (placeholderItem.style.display = 'block')
      if (!dropItem) {
        targetY = targetY > 1 ? targetY -1 : targetY
        console.log('添加新的组件中', shape)
        const w = this.colNum
        // const h = this.hShapeMap[shape] || 500
        const h = 20
        const x = 0
        this.DragPos.h = h 
        this.DragPos.w = w
        this.DragPos.x = x 
        this.DragPos.y = targetY === 0 ? -1 : targetY
        this.gridLayout.push({
          w,
          h,
          x,
          y: targetY === 0 ? -1 : targetY,
          i: 'drop'
        })
      } else {
        let placeholderItem = null
        try {
          placeholderItem = this.$refs.gridLayout.$children[this.layout.length]
          placeholderItem && (placeholderItem.$refs.item.style.display = "none")
        } catch {}
        let el = this.$refs.gridLayout.$children[index]
        el.innerW = this.colNum
        this.$refs.gridLayout.dragEvent("dragstart", "drop", 0, targetY === 0 ? -1 : targetY, this.DragPos.h, this.DragPos.w)
      }
    }, 150),
    handleOuterDragAdd() {
      const dropItem = this.gridLayout.find(item => item.i === "drop")
      if (dropItem) {
        // 说明是可以新增组件的状态的， 
        this.canAdd = true
      }
    },
    clearSwiperElementActive() {
      const clearActive = {
        ...this.ids
      }
      for (const k in clearActive) {
        if (clearActive[k] === null) delete clearActive[k]
      }
      if (clearActive.hasOwnProperty("elementInSwiperId") && clearActive.elementInSwiperId !== null) {
        clearActive.elementInSwiperId = null
        this.$store.dispatch(this.request_prefix + "/changeElementInSwiperActive", clearActive)
      }
    },
    clearAutoLayoutElementActive(elementOptions) {
      let container = this.originStage.page.children.find(
        children => children.container_id === this.ids.container_id
      )
      if (!container?.children) return
      let rect = this.getAttrById.call(
        this,
        this.originStage,
        JSON.parse(JSON.stringify(this.ids)),
        "autoLayout"
      )
      const rectOptions = rect && rect.options ? rect.options : rect
      let rectElement = rectOptions && rectOptions.elementOptions ? rectOptions.elementOptions : []
      elementOptions = elementOptions || rectElement
      elementOptions.forEach(item => {
        let param = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          uid: this.ids.uid,
          elementInLayoutId: rectOptions?.elementInLayoutId,
          elementInAutoLayoutId: rectOptions?.elementInAutoLayoutId,
          path: rectOptions?.path
        }
        this.$store.dispatch(this.request_prefix + "/changeElementInAutoLayoutUnActive", param)
        if (item.elementOptions && item.elementOptions.length > 0) {
          this.clearAutoLayoutElementActive(item.elementOptions)
        }
      })
    },
    activateEv(id, index, shape, active, activeGridId) {
      this.activeGridId = null
      if (this.forbidActive) {
        return
      }
      const oldIds = JSON.parse(JSON.stringify(this.ids))
      const oldAttr = oldIds.hasOwnProperty("rect_id")
        ? this.getRectAttribute.call(this, JSON.parse(JSON.stringify(this.ids)))
        : ""
      this.activeIndex = active
      // isShade 是判断是否是上层的遮罩
      // 控制缓存组件的appid同步
      this.clearSwiperElementActive()
      this.clearAutoLayoutElementActive()
      //取消title内选中态
      if (this.ids.directionIndex !== undefined) {
        this.$store.dispatch(this.request_prefix + "/delAllLayoutTitleActive", this.ids)
      }
      const myAttr = this.getRectAttribute.call(this, { container_id: id, rect_id: index })
      const myAppId = myAttr.appId

      if (myAppId) {
        const { moduleId, typeId } = this.getRectAttribute.call(this, { container_id: id, rect_id: index })
        this.initDataPageIds({ moduleId, typeId, appId: myAppId.appId })
      }

      if (JSON.parse(window.localStorage.getItem("oldActiveData")) !== "nothing") {
        let param = JSON.parse(window.localStorage.getItem("oldActiveData"))
        if (param && (param.container_id !== id || param.rect_id !== index) && param.uid) {
          param.option_name = "isActive"
          param.option_val = false
          this.$store.dispatch(this.request_prefix + "/changeLayoutActive", param)
        }
      }
      if (!this.$store.state.states.alignHelperStatus && !localStorage.getItem("multipleComponent")) {
        this.$store.dispatch(this.request_prefix + "/setActive", {
          container_id: id,
          rect_id: index
        })
        // 选中自由布局时清除掉自由布局内元素的选中状态
        if (myAttr?.shape === "emptyLayoutComponent" || myAttr?.shape === "cxAutoLayout") {
          let param = {
            container_id: id,
            rect_id: index,
            option_name: "isActive",
            option_val: "delAllActive"
          }
          this.$store.dispatch(this.request_prefix + "/changeLayoutActive", param)
        }
        //    }
      } else {
        this.$store.commit(this.request_prefix + "/ENABLE_ACTIVE", {
          container_id: id,
          rect_id: index
        })
        let newArr = JSON.parse(sessionStorage.getItem("tmpComponents")) || []
        if (localStorage.getItem("multipleComponent")) {
          newArr.push({
            container_id: id,
            rect_id: index
          })
        }else{
          newArr =[{
            container_id: id,
            rect_id: index
          }]
        }
        sessionStorage.setItem("tmpComponents", JSON.stringify(newArr))
      }
      if (id !== null && index !== null && !shape.toLowerCase().includes("layoutComponent")) {
        // 放开了轮播图未激活时  在此激活的情况
        if (this.ids.container_id === id && this.ids.rect_id === index && Object.keys(this.ids)?.length === 2) {
          return
        }
        let param = {
          container_id: id,
          rect_id: index
        }
        console.log("activeParam", param)
        this.$store.commit("states/changeActiveID", param)
        this.$store.commit("states/changeElementType", shape)
      }
      // 增加上层布局的层级
      $(".layout-container.set_active").removeClass("set_active active")
      $(".page-layout-wrapper[data-level='top-level']").removeAttr("data-level")
      $(".layout-col.zIndex999").removeClass("zIndex999")
      $(this.$el).parents(".layout-col").addClass("zIndex999")
      $($(this.$el).parents(".page-layout-wrapper")[0]).attr("data-level", "top-level")
      this.showRightToolbar = true
    },
    deactivateEv(id, index, shape) {
      if (this.$store.state.states.isOrderPattern) {
        return
      }
      if (!this.$store.state.states.elementType) {
        this.$store.commit("states/changeElementType", null)
      }
      this.$store.dispatch(this.request_prefix + "/unsetActive", {
        container_id: id,
        rect_id: index
      })
      // 增加上层布局的层级
      $(this.$el).parents(".layout-col").removeClass("zIndex999")
      $($(this.$el).parents(".page-layout-wrapper")[0]).removeAttr("data-level")
    },
    vdrMouseenterEvent(rectShape, gridId) {
      sessionStorage.setItem("vdrMouseenterEvent", true)
      if (this.baseComponent.indexOf(rectShape) === -1) {
        $(`.${gridId}`).addClass("grid-hover")
      }
    },
    vdrMouseLeaveEvent(rectShape, gridId) {
      sessionStorage.removeItem("vdrMouseenterEvent")
      if (this.baseComponent.indexOf(rectShape) === -1) {
        // $(`.${gridId}`).removeClass('grid-hover')
      }
    },
    // 开始拖拽
    resizeEnter(rect) {
      // if (rect && rect.length > 0) {
      //   let component = rect.find(item => this?.baseComponent?.indexOf(item.shape) === -1) // 非基础组件
      //   if (component) {
      //     // 当鼠标拖拽上下箭头时不丢失自由布局的悬浮态
      //     $(`.container_id_${this.id}-rect_id_${component.rect_id}:not(.active)`).addClass("vdr_hover")
      //     $(`.container_id_${this.id}-rect_id_${component.rect_id}:not(.active) .handle-btn-groups`).removeClass("isHid")
      //     $(`.container_id_${this.id}-rect_id_${component.rect_id}:not(.active) .handle-btn-groups`).addClass("isShow")
      //   }
      // }
    },
    // 结束拖拽
    resizeLeave(rect) {
      // console.log("leave111")
      // this.isResizing = false
      // this.gridResizingId = null
      // this.handleResizing(false)
      // if (rect && rect.length > 0) {
      //   let component = rect.find(item => this?.baseComponent?.indexOf(item.shape) === -1) // 非基础组件
      //   if (component) {
      //     $(`.container_id_${this.id}-rect_id_${component.rect_id}:not(.active)`).removeClass("vdr_hover")
      //     $(`.container_id_${this.id}-rect_id_${component.rect_id}:not(.active) .handle-btn-groups`).removeClass("isShow")
      //     $(`.container_id_${this.id}-rect_id_${component.rect_id}:not(.active) .handle-btn-groups`).addClass("isHid")
      //   }
      // }
    },
    // 获取当前快照
    getQuickShot() {
      const pageLayoutList = this.originStage.page.pageLayoutList
      const ids = this.pageLayoutId.split("_")
      const rect = pageLayoutList[ids[0]]
      return deepCloneAndFreeze(rect)
    },
    // 记录状态
    addHistory() {
      const pageLayoutList = this.originStage.page.pageLayoutList
      const ids = this.pageLayoutId.split("_")
      const rect = pageLayoutList[ids[0]]
      const newData = this.getQuickShot()
      this.$addHistory({
        type: "update",
        stateType: "updatePageLayout",
        payload: {
          container_id: this.ids.container_id,
          pageLayoutId: rect.id
        },
        before: this.before,
        data: newData
      })
      this.before = null
    }
  }
}
</script>
<style lang="scss" scoped>
.handle-move {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  font-size: 12px;
  cursor: move;
  z-index: 0;
}
.vue-grid-layout {
  height: 100px;
}
.grid-item-content {
  position: relative;
  width: 100%;
  height: 100%;
  // overflow: hidden;
  background: transparent;
}
.vue-grid-item:not(.vue-grid-placeholder) {
  background: transparent;
  // 由组件自身的内边距设置
  //padding: 10px;
  overflow: visible;
  box-sizing: border-box;
}
.vue-grid-item.hover:not(.no-border) {
  z-index: 10000;
  // 设置层级是为了处理此时能正常展示，点击删除按钮
  .new-btn-groups {
    display: block;
  }
}
//.vue-grid-item.grid-dragging,
.vue-grid-item.vue-draggable-dragging {
  z-index: 10001;
}
::v-deep .vue-grid-item.vue-grid-placeholder {
  background: rgba(232, 242, 255, 1);
  opacity: 1;
  border: 1px dashed rgba(43, 103, 255, 1);
}
::v-deep .vue-grid-layout:not(.isResizing) .vue-grid-item.vue-grid-placeholder {
  z-index: 9998;
}

.vue-grid-item .resizing {
  opacity: 0.9;
}
::v-deep .vue-grid-item:hover .position-control,
::v-deep .vue-grid-item:hover .size-control {
  // 不能删除 悬浮到内部组件时也会触发hover
  display: none;
}
::v-deep .vue-grid-item.grid-rect-active .position-control,
::v-deep .vue-grid-item.grid-rect-active .size-control {
  display: inline-block;
  z-index: 100001;
}
//::v-deep .vue-grid-item.no-border:hover .position-control,
//::v-deep .vue-grid-item.no-border:hover .size-control{
//  display: inline-block;
//}
// 悬浮用class决定
::v-deep .vue-grid-item.hover .position-control,
::v-deep .vue-grid-item.hover .size-control,
::v-deep .vue-grid-item.active .size-control {
  display: inline-block;
}
::v-deep .size-control {
  border-color: var(--themeColor);
}
.vue-grid-item .static {
  background: #cce;
}

.vue-grid-item .text {
  font-size: 24px;
  text-align: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: 100%;
  width: 100%;
}

.vue-grid-item .no-drag {
  height: 100%;
  width: 100%;
}

.vue-grid-item .minMax {
  font-size: 12px;
}

.vue-grid-item .add {
  cursor: pointer;
}
.remove {
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}
//.hover-active{
//  box-shadow: 0 0 0 2px var(--themeColor);
//}
.vue-grid-item .is_full_rect {
  width: 100% !important;
  height: 100% !important;
  transform: translate(0,0) !important;
}
::v-deep.water-container {
  .vue-grid-item {
    .vue-resizable-handle {
      display: none;
      z-index: 10000;
    }
    &.hover {
      .vue-resizable-handle {
        display: inline-block;
      }
    }
  }
}
.new-btn-groups {
  position: absolute;
  display: none;
  left: 0;
  right: auto;
  top: auto !important;
  bottom: 100%;
  background: #fff;
  padding: 2px 5px;
  -webkit-box-shadow: 0px 3px 6px 0px rgb(0 0 0 / 7%);
  box-shadow: 0px 3px 6px 0px rgb(0 0 0 / 7%);
  border: 1px solid #e9e9e9;
  border-radius: 6px;
}
.vue-grid-item:not(.vue-grid-placeholder) {
  &.hover {
    & > .border-handle {
      border-color: var(--themeColor) !important;
    }
  }
  &.grid-rect-active,
  &.active {
    z-index: 9999!important;
  }
  &.grid-hover {
    z-index: 10000 !important;
  }
  &.grid-hover {
    & > .handle-tb,
    & > .handle-bb {
      border-top: 1px dashed var(--themeColor) !important;
    }
    & > .handle-rb,
    & > .handle-lb {
      border-left: 1px dashed var(--themeColor) !important;
    }
  }
  &.active {
    & > .handle-tb,
    & > .handle-bb {
      border-top: 2px dashed var(--themeColor) !important;
    }
    & > .handle-rb,
    & > .handle-lb {
      border-left: 2px dashed var(--themeColor) !important;
    }
    .new-btn-groups {
      display: block;
    }
  }
  &.grid-active.dragging {
    & > .handle-tb,
    & > .handle-bb,
    & > .handle-rb,
    & > .handle-lb {
      border-color: var(--themeColor) !important;
    }
  }
}
.vue-grid-item.no-border > .border-handle,
.vue-grid-item.grid-rect-active > .border-handle {
  border: none;
}
.border-handle {
  background: transparent;
  position: absolute;
}
.handle-tb {
  height: 0;
  left: 0;
  right: 0;
  width: 100%;
  border-top: 1px dashed var(--thirdTextColor);
}
.handle-rb {
  height: 100%;
  right: 0;
  width: 0;
  border: 0;
  border-left: 1px dashed var(--thirdTextColor);
}
.handle-bb {
  height: 0;
  left: 0;
  right: 0;
  width: 100%;
  bottom: 0;
  border: 0;
  border-top: 1px dashed var(--thirdTextColor);
}
.handle-lb {
  height: 100%;
  top: 0;
  left: 0;
  width: 0;
  border: 0;
  border-left: 1px dashed var(--thirdTextColor);
}
.empty-rect-tip {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: var(--thirdTextColor);
  pointer-events: none;
  .empty-rect-bg {
    width: 82px;
    height: 68px;
    margin: 0 auto 14px;
    background: url("../../../assets/images/empty_bay_window.png");
    background-size: contain;
  }
}
::v-deep .position-left-control,
::v-deep .position-right-control,
::v-deep .position-bottom-control,
::v-deep .position-top-control {
  border: none !important;
}
.size-popover {
  position: absolute;
  background: rgba(24, 30, 51, 0.8);
  border-radius: 4px;
  top: -32px;
  left: 0;
  z-index: 10;
  font-size: 12px;
  line-height: 17px;
  padding: 5px 12px;
  color: #fff;
}
//.vue-grid-item.resizing{
//  opacity: 1!important;
//}
.drag-tip {
  position: absolute;
  top: -32px;
  left: 50%;
  transform: translateX(-50%);
  padding: 2px 4px;
  line-height: 24px;
  border: 1px solid rgba(233, 233, 233, 1);
  border-radius: 2px;
  background-color: #fff;
  color: rgba(0, 0, 0, 0.8);
  font-size: 13px;
}
::v-deep .loading-wrap{
  display: none;
}
::v-deep .loading-newRect.loading-wrap {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999999;
  text-align: center;
  background: var(--defaultButtonHover);
  color: var(--thirdTextColor);
}
::v-deep .loading-newRect.loading-wrap .loading-wrap+.empty-rect-tip{
  display: none;
}
::v-deep .loading-newRect.loading-wrap .loading-rect-box{
  position: absolute;
  top:50%;
  left: 50%;
  transform: translate(-50%,-50%);
}
::v-deep .loading-newRect.loading-wrap .icon{
  display: inline-block;
  margin-bottom: 4px;
  font-size: 24px;
  transform: rotate(90deg);
  animation: rotation 1s linear infinite;
}
::v-deep .loading-wrap  p{
  line-height: 20px;
  font-size: 16px;
}
</style>
